module.exports = __webpack_public_path__ + "img/pl-2.90e5da4.jpeg";